__turbopack_context__.v({
  "ebayButton": "styles-module__LXtaIq__ebayButton",
  "icon": "styles-module__LXtaIq__icon",
  "label": "styles-module__LXtaIq__label",
});
